export default __webpack_public_path__ + "static/articards-screenshot-708fa049f5e3fff99fc32af274f4bb0e.png";